import { useParams } from "react-router-dom";
import { isTaskRejectProducts } from "tm-shared/utils";

import { usePointSelector, useTaskSelector } from "@/hooks/redux";
import NotFound from "@/pages/System/NotFound";

import { RejectProductsPage } from "./RejectProductsPage";

const RejectProducts = () => {
    const { pointId = "", taskId = "" } = useParams();

    const currentTask = useTaskSelector(pointId, taskId);
    const currentPoint = usePointSelector(pointId);

    if (!currentTask || !isTaskRejectProducts(currentTask) || !currentPoint)
        return <NotFound />;

    return <RejectProductsPage point={currentPoint} task={currentTask} />;
};

export default RejectProducts;
